import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import DataAI from "@/pages/DataAI";
import Solutions from "@/pages/Solutions";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Company from "@/pages/Company";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import JobDetail from "@/pages/JobDetail";
import StartProject from "@/pages/StartProject";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-tark-bg text-tark-ink">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/services/:slug" element={<PublicLayout><ServiceDetail /></PublicLayout>} />
          <Route path="/data-ai" element={<PublicLayout><DataAI /></PublicLayout>} />
          <Route path="/solutions" element={<PublicLayout><Solutions /></PublicLayout>} />
          <Route path="/industries" element={<PublicLayout><Industries /></PublicLayout>} />
          <Route path="/industries/:slug" element={<PublicLayout><IndustryDetail /></PublicLayout>} />
          <Route path="/company" element={<PublicLayout><Company /></PublicLayout>} />
          <Route path="/insights" element={<PublicLayout><Insights /></PublicLayout>} />
          <Route path="/insights/:slug" element={<PublicLayout><InsightDetail /></PublicLayout>} />
          <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
          <Route path="/careers/jobs/:id" element={<PublicLayout><JobDetail /></PublicLayout>} />
          <Route path="/start-a-project" element={<PublicLayout><StartProject /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<PublicLayout><Home /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{
        style: { background: "#101520", border: "1px solid #1E293B", color: "#F8FAFC" },
      }} />
    </div>
  );
}

export default App;
